(function() {

	angular
		.module('ngmvac')
		.directive('popover', Popover);

	function Popover() {
		return {
			restrict: 'A',
			link: function(scope, element, attrs) {
				$(element).popover();
			}
		}
	}

})();